import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api-client';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: true,
      retry(failureCount, error) {
        // 4xx means the request itself is wrong — retrying just repeats the mistake.
        if (error instanceof ApiError && error.status < 500) return false;
        return failureCount < 2;
      },
    },
    mutations: {
      retry: false,
    },
  },
});

/** Query key factory. Central so an invalidation cannot miss a key by typo. */
export const queryKeys = {
  auth: {
    me: ['auth', 'me'] as const,
  },
  dashboard: {
    tutor: ['dashboard', 'tutor'] as const,
    student: ['dashboard', 'student'] as const,
  },
  lessons: {
    all: ['lessons'] as const,
    list: (filters: Record<string, unknown>) => ['lessons', 'list', filters] as const,
    detail: (id: string) => ['lessons', 'detail', id] as const,
    classroom: (id: string) => ['lessons', 'classroom', id] as const,
  },
  students: {
    all: ['students'] as const,
    list: (filters: Record<string, unknown>) => ['students', 'list', filters] as const,
    detail: (id: string) => ['students', 'detail', id] as const,
  },
  homework: {
    all: ['homework'] as const,
    list: (filters: Record<string, unknown>) => ['homework', 'list', filters] as const,
    detail: (id: string) => ['homework', 'detail', id] as const,
    templates: (page: number) => ['homework', 'templates', page] as const,
  },
  progress: {
    mine: ['progress', 'me'] as const,
    student: (id: string) => ['progress', 'student', id] as const,
  },
  resources: {
    list: (filters: Record<string, unknown>) => ['resources', filters] as const,
  },
  notifications: {
    list: ['notifications'] as const,
  },
  profile: {
    me: ['profile', 'me'] as const,
  },
} as const;
